module.exports = __webpack_public_path__ + "img/1.a78e2c1b.png";